import Vue from "vue";
import Vuex from "vuex";
import config from "./const";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentStep: 1,
    maxStep: 1,
    zip: null,
    address1: null,
    address2: null,
    address3: null,
    isInServiceArea: false, // 取付可能エリアか？
    hasRecycling: null,
    hasRemoval: null,
    hasConstruction: null,
    airconType: null,
    hasSocket: null,
    socketType: null,
    hasHole: null,
    holeType: null,
    sameFloor: null,
    extentionTube: null,
    unitType: null,
    unitFloor: null,
    total: 0,
    removal: 0,
    recycling: 0,
    standard: 0,
    additional: 0,

    priceDetail: [],
    grandTotal: 0,
    calendars: null,
    calendar: null,
  },
  getters: {
    address: (state) => {
      return {
        address1: state.address1,
        address2: state.address2,
        address3: state.address3,
      };
    },
    isInServiceArea: (state) => {
      return state.isInServiceArea;
    },
    zip: (state) => {
      return state.zip;
    },
    currentStep: (state) => {
      return state.currentStep;
    },
    maxStep: (state) => {
      return state.maxStep;
    },
    total: (state) => {
      return state.total;
    },
    removal: (state) => {
      return state.removal;
    },
    recycling: (state) => {
      return state.recycling;
    },
    standard: (state) => {
      return state.standard;
    },
    additional: (state) => {
      return state.additional;
    },
    grandTotal: (state) => {
      return state.grandTotal;
    },
    priceDetail: (state) => {
      return state.priceDetail;
    },
    calendars: (state) => {
      return state.calendars;
    },
    calendar: (state) => {
      return state.calendar;
    },
    airconType: (state) => {
      return state.airconType;
    },
    hasConstruction: (state) => {
      return state.hasConstruction;
    },
    hasSocket: (state) => {
      return state.hasSocket;
    },
    hasHole: (state) => {
      return state.hasHole;
    },
    sameFloor: (state) => {
      return state.sameFloor;
    },
    unitType: (state) => {
      return state.unitType;
    },
    priceForMail: (state) => {
      let result = [];
      for (const i in state.priceDetail) {
        console.log('priceDetail', state.priceDetail[i].answers)
        let answer = [];
        answer.push({
          question: config.PRICE_FOR_MAIL['hasRemoval'].question,
          answer: config.PRICE_FOR_MAIL['hasRemoval'].answers[state.priceDetail[i].answers.hasRemoval].answer,
          price: config.PRICE_FOR_MAIL['hasRemoval'].answers[state.priceDetail[i].answers.hasRemoval].price,
        });
        answer.push({
          question: config.PRICE_FOR_MAIL['hasRecycling'].question,
          answer: config.PRICE_FOR_MAIL['hasRecycling'].answers[state.priceDetail[i].answers.hasRecycling].answer,
          price: config.PRICE_FOR_MAIL['hasRecycling'].answers[state.priceDetail[i].answers.hasRecycling].price,
        });
        answer.push({
          question: config.PRICE_FOR_MAIL['airconType'].question,
          answer: config.PRICE_FOR_MAIL['airconType'].answers[state.priceDetail[i].answers.airconType].answer,
          price: config.PRICE_FOR_MAIL['airconType'].answers[state.priceDetail[i].answers.airconType].price,
        });
        answer.push({
          question: config.PRICE_FOR_MAIL['hasSocket'].question,
          answer: config.PRICE_FOR_MAIL['hasSocket'].answers[state.priceDetail[i].answers.hasSocket].answer,
          price: config.PRICE_FOR_MAIL['hasSocket'].answers[state.priceDetail[i].answers.hasSocket].price,
        });
        if (state.priceDetail[i].answers.hasSocket === 1) {
          answer.push({
            question: config.PRICE_FOR_MAIL['socketType'].question,
            answer: '専用コンセントが近くにない',
            price: 0,
          });
        } else {
          answer.push({
            question: config.PRICE_FOR_MAIL['socketType'].question,
            answer: config.PRICE_FOR_MAIL['socketType'].answers[state.priceDetail[i].answers.socketType].answer,
            price: config.PRICE_FOR_MAIL['socketType'].answers[state.priceDetail[i].answers.socketType].price,
          });
        }
        answer.push({
          question: config.PRICE_FOR_MAIL['hasHole'].question,
          answer: config.PRICE_FOR_MAIL['hasHole'].answers[state.priceDetail[i].answers.hasHole].answer,
          price: config.PRICE_FOR_MAIL['hasHole'].answers[state.priceDetail[i].answers.hasHole].price,
        });
        if (state.priceDetail[i].answers.hasHole === 0) {
          answer.push({
            question: config.PRICE_FOR_MAIL['holeType'].question,
            answer: config.PRICE_FOR_MAIL['holeType'].answers[state.priceDetail[i].answers.holeType].answer,
            price: config.PRICE_FOR_MAIL['holeType'].answers[state.priceDetail[i].answers.holeType].price,
          });
        } else {
          answer.push({
            question: config.PRICE_FOR_MAIL['holeType'].question,
            answer: '穴がない',
            price: 0,
          });
        }
        answer.push({
          question: config.PRICE_FOR_MAIL['sameFloor'].question,
          answer: config.PRICE_FOR_MAIL['sameFloor'].answers[state.priceDetail[i].answers.sameFloor].answer,
          price: config.PRICE_FOR_MAIL['sameFloor'].answers[state.priceDetail[i].answers.sameFloor].price,
        });
        if (state.priceDetail[i].answers.sameFloor === 0) {
          answer.push({
            question: config.PRICE_FOR_MAIL['extentionTube'].question,
            answer: config.PRICE_FOR_MAIL['extentionTube'].answers[state.priceDetail[i].answers.extentionTube].answer,
            price: config.PRICE_FOR_MAIL['extentionTube'].answers[state.priceDetail[i].answers.extentionTube].price,
          });
        } else {
          answer.push({
            question: config.PRICE_FOR_MAIL['extentionTube'].question,
            answer: '室外機を同じ階に設置できない',
            price: 0,
          });
        }
        answer.push({
          question: config.PRICE_FOR_MAIL['unitType'].question,
          answer: config.PRICE_FOR_MAIL['unitType'].answers[state.priceDetail[i].answers.unitType].answer,
          price: config.PRICE_FOR_MAIL['unitType'].answers[state.priceDetail[i].answers.unitType].price,
        });
        if (
          state.priceDetail[i].answers.unitType === 2 ||
          state.priceDetail[i].answers.unitType === 3 ||
          state.priceDetail[i].answers.unitType === 6 ||
          state.priceDetail[i].answers.unitType === 7
        ) {
          answer.push({
            question: config.PRICE_FOR_MAIL['unitFloor'].question,
            answer: config.PRICE_FOR_MAIL['unitFloor'].answers[state.priceDetail[i].answers.unitFloor].answer,
            price: config.PRICE_FOR_MAIL['unitFloor'].answers[state.priceDetail[i].answers.unitFloor].price,
          });  
        } else {
          answer.push({
            question: config.PRICE_FOR_MAIL['unitFloor'].question,
            answer: '高所作業なし',
            price: 0,
          });  
        }

        result.push({
          additional: state.priceDetail[i].additional,
          recycling: state.priceDetail[i].recycling,
          removal: state.priceDetail[i].removal,
          standard: state.priceDetail[i].standard,
          total: state.priceDetail[i].total,
          answers: answer,
        });
      }
      return result;
    },
  },
  mutations: {
    saveAddress(state, src) {
      state.address1 = src.address1;
      state.address2 = src.address2;
      state.address3 = src.address3;
      state.isInServiceArea = src.isInServiceArea;
    },
    saveZip(state, src) {
      state.zip = src;
    },
    saveCalendars(state, src) {
      state.calendars = src;
    },
    saveCalendar(state, src) {
      state.calendar = src;
    },
    saveAnswer(state, src) {
      console.log('keyword:', src.keyword, 'answer:', src.answer)
      if (src.keyword == 'unit_floor') {
        state.unitFloor = src.answer;
      } else if (src.keyword == 'has_recycling') {
        state.hasRecycling = src.answer;
      } else if (src.keyword == 'has_removal') {
        state.hasRemoval = src.answer;
      } else if (src.keyword == 'has_construction') {
        state.hasConstruction = src.answer;
      } else if (src.keyword == 'aircon_type') {
        state.airconType = src.answer;
      } else if (src.keyword == 'has_socket') {
        state.hasSocket = src.answer;
      } else if (src.keyword == 'socket_type') {
        state.socketType = src.answer;
      } else if (src.keyword == 'has_hole') {
        state.hasHole = src.answer;
      } else if (src.keyword == 'hole_type') {
        state.holeType = src.answer;
      } else if (src.keyword == 'same_floor') {
        state.sameFloor = src.answer;
      } else if (src.keyword == 'extention_tube') {
        state.extentionTube = src.answer;
      } else if (src.keyword == 'unit_type') {
        state.unitType = src.answer;
      }
      // 料金表を見て対応する金額を加算
      state.removal = state.hasRemoval == null ? 0 : config.PRICES['hasRemoval'][state.hasRemoval];
      state.recycling = state.hasRecycling == null ? 0 : config.PRICES['hasRecycling'][state.hasRecycling];
      state.standard = state.airconType == null ? 0 : config.PRICES['airconType'][state.airconType];
      let additional = 0;
      additional += state.hasSocket == null ? 0 : config.PRICES['hasSocket'][state.hasSocket];
      additional += state.hasHole == null ? 0 : config.PRICES['hasHole'][state.hasHole];
      additional += state.holeType == null ? 0 : config.PRICES['holeType'][state.holeType];
      additional += state.sameFloor == null ? 0 : config.PRICES['sameFloor'][state.sameFloor];
      additional += state.extentionTube == null ? 0 : config.PRICES['extentionTube'][state.extentionTube];
      additional += state.unitType == null ? 0 : config.PRICES['unitType'][state.unitType];
      additional += state.unitFloor == null ? 0 : config.PRICES['unitFloor'][state.unitFloor];
      state.additional = additional;
      state.total =
        state.removal + state.recycling + state.standard + state.additional;
      let grandTotal = state.total;
      for (let i = 0; i < state.priceDetail.length; i++) {
        grandTotal += state.priceDetail[i].total;
      }
      state.grandTotal = grandTotal;
    },
    updateStep(state, src) {
      // console.log('updateStep', src)
      if (state.currentStep < state.maxStep) {
        state.currentStep = state.maxStep;
      } else {
        state.currentStep = src;
        state.maxStep = src;
      }
    },
    updateMaxStep(state, src) {
      state.maxStep = src;
    },
    // 2台目のシミュレーションのためにデータを初期化
    pushPriceDetail(state, src) {
      console.log(src);
      state.priceDetail.push({
        total: state.total,
        removal: state.removal,
        recycling: state.recycling,
        standard: state.standard,
        additional: state.additional,
        answers: {
          unitFloor: state.unitFloor,
          hasRecycling: state.hasRecycling,
          hasRemoval: state.hasRemoval,
          hasConstruction: state.hasConstruction,
          airconType: state.airconType,
          hasSocket: state.hasSocket,
          socketType: state.socketType,
          hasHole: state.hasHole,
          holeType: state.holeType,
          sameFloor: state.sameFloor,
          extentionTube: state.extentionTube,
          unitType: state.unitType,
        },
      });
      state.total = 0;
      state.recycling = 0;
      state.removal = 0;
      state.standard = 0;
      state.additional = 0;
      state.currentStep = 2;
      state.maxStep = 2;
      state.unitFloor = null;
      state.hasRecycling = null;
      state.hasRemoval = null;
      state.hasConstruction = null;
      state.airconType = null;
      state.hasSocket = null;
      state.socketType = null;
      state.hasHole = null;
      state.holeType = null;
      state.sameFloor = null;
      state.extentionTube = null;
      state.unitType = null;
    },
    // 査定見積もりの削除
    removeEstimation(state, src) {
      state.priceDetail.splice(src, 1);
      // 合計金額の変更
      let grandTotal = state.total;
      for (let i = 0; i < state.priceDetail.length; i++) {
        grandTotal += state.priceDetail[i].total;
      }
      state.grandTotal = grandTotal;
    },
    // 現在査定中のデータをカラに
    removeCurrentEstimation(state) {
      state.total = 0;
      state.recycling = 0;
      state.removal = 0;
      state.standard = 0;
      state.additional = 0;
      state.currentStep = 2;
      state.maxStep = 2;
      state.unitFloor = null;
      state.hasRecycling = null;
      state.hasRemoval = null;
      state.hasConstruction = null;
      state.airconType = null;
      state.hasSocket = null;
      state.socketType = null;
      state.hasHole = null;
      state.holeType = null;
      state.sameFloor = null;
      state.extentionTube = null;
      state.unitType = null;
      // 合計金額の変更
      let grandTotal = 0;
      for (let i = 0; i < state.priceDetail.length; i++) {
        grandTotal += state.priceDetail[i].total;
      }
      state.grandTotal = grandTotal;
    },
  },
  actions: {
    doSaveAddress({ commit }, src) {
      commit("saveAddress", src);
    },
    doSaveZip({ commit }, src) {
      commit("saveZip", src);
    },
    doSaveAnswer({ commit }, src) {
      commit("saveAnswer", src);
    },
    doUpdateStep({ commit }, src) {
      // console.log(src)
      commit("updateStep", src);
    },
    doUpdateMaxStep({ commit }, src) {
      // console.log(src)
      commit("updateMaxStep", src);
    },
    doPushPriceDetail({ commit }, src) {
      commit("pushPriceDetail", src);
    },
    doSaveCalendars({ commit }, src) {
      commit("saveCalendars", src);
    },
    doSaveCalendar({ commit }, src) {
      commit("saveCalendar", src);
    },
    doRemoveEstimation({ commit }, src) {
      commit("removeEstimation", src);
    },
    doRemoveCurrentEstimation({ commit }) {
      commit("removeCurrentEstimation");
    },
  },
});
